// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"3a933d8c0a8646621a68","6980":"772c7d94a879ac1aca8d"}[chunkId] + ".js";
};